import { GoogleMap, Marker, Polyline, PolylineF, useJsApiLoader } from "@react-google-maps/api";
import { Label } from "components/input/Label";
import Endereco from "model/transportes/endereco/Endereco";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { fromLatLng, geocode, OutputFormat, RequestType, setDefaults } from "react-geocode";
import "./mapaPercurso.scss";
import { InputTextarea } from "primereact/inputtextarea";
import ItemRotaPontoPercurso from "model/transportes/rota/ItemRotaPontoPercurso";

type Props = {
    destino: Endereco;
    pontosPercurso: ItemRotaPontoPercurso[];
}
let polylineRef: google.maps.Polyline | null = null;
export default function MapaPercurso(props: Props) {
    const keyMaps = 'AIzaSyDQbLYImEY_K1U92ocx6-e46qC2AjskIfo';
    const [localizacaoInicio, setLocalizacaoInicio] = useState<{ lat: number, lng: number } | null>(null);
    const [localizacaoDestino, setLocalizacaoDestino] = useState<{ lat: number, lng: number } | null>(null);
    const [pontosPercurso, setPontosPercurso] = useState<ItemRotaPontoPercurso[]>([]);
    const [center, setCenter] = useState({ lat: -28.6782, lng: -49.370176 });

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: keyMaps,
    })

    const [map, setMap] = useState<google.maps.Map | null>(null)

    useEffect(() => {
        setDefaults({
            key: keyMaps,
            language: "pt",
            region: "br",
            outputFormat: OutputFormat.JSON
        });
    }, [])

    useEffect(() => {
        if (isLoaded && props.destino.latitude && props.destino.longitude) {
            polylineRef?.setMap(null);
            setLocalizacaoDestino({
                lat: props.destino.latitude,
                lng: props.destino.longitude
            });
            if (props.pontosPercurso.length > 0) {
                setLocalizacaoInicio({
                    lat: props.pontosPercurso[0].latitude,
                    lng: props.pontosPercurso[0].longitude
                });
            } else {
                setLocalizacaoInicio(null);
            }
            setPontosPercurso(props.pontosPercurso);
            setCenter({
                lat: props.destino.latitude,
                lng: props.destino.longitude
            });
        }
    }, [isLoaded, props.destino.latitude, props.pontosPercurso]);

    useEffect(() => {

    }, [localizacaoDestino])

    return (
        <div>
            <div className="form-container">
                <div className="form-row">
                    <div className="form-item">
                        <Label>Estado</Label>
                        <InputText value={props.destino.estado} placeholder="Estado" />
                    </div>

                    <div className="form-item">
                        <Label>Cidade</Label>
                        <InputText value={props.destino.cidade} placeholder="Cidade" />
                    </div>
                    <div className="form-item">
                        <Label>Bairro</Label>
                        <InputText value={props.destino.bairro} placeholder="Bairro" />
                    </div>
                    <div className="form-item">
                        <Label>CEP</Label>
                        <InputText value={props.destino.cep} placeholder="CEP" />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-item">
                        <Label>Logradouro</Label>
                        <InputText value={props.destino.logradouro} placeholder="Logradouro" />
                    </div>
                    <div className="form-item">
                        <Label>Número</Label>
                        <InputText value={(props.destino.numero || 0) + ""} placeholder="Número" />
                    </div>
                    <div className="form-item">
                        <Label>Complemento</Label>
                        <InputText value={props.destino.complemento} placeholder="Complemento" />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-item">
                        <Label>Observação</Label>
                        <InputTextarea className="textarea-item" placeholder="Digite informações adicionais aqui" value={props.destino.observacao + ""} />
                    </div>
                </div>
            </div>

            <Label>Percurso</Label>
            {isLoaded ? <GoogleMap
                onLoad={(map) => {
                    const bounds = new window.google.maps.LatLngBounds(center)
                    map.fitBounds(bounds)
                    var listener = google.maps.event.addListener(map, "idle", function () {
                        if ((map.getZoom() || 0) > 15) map.setZoom(15);
                        google.maps.event.removeListener(listener);
                    })
                    setMap(map);
                }}
                zoom={15}
                center={center}
                onUnmount={() => { }}
                mapContainerStyle={{
                    height: "400px",
                    width: "824px"
                }}
            >
                {localizacaoInicio ? <Marker position={localizacaoInicio} /> : null}
                {pontosPercurso.length > 0 ? <PolylineF
                    onLoad={(polyline) => {
                        polylineRef = polyline;
                    }}
                    path={pontosPercurso.map(ponto => ({ lat: ponto.latitude, lng: ponto.longitude })) || []}
                    key={props.destino.id}
                    visible={pontosPercurso.length > 0}
                    options={{
                        strokeColor: "#240E92",
                        strokeOpacity: 0.5,
                        strokeWeight: 5,
                        geodesic: true,
                        clickable: true
                    }}
                /> : null}
                {localizacaoDestino ? <Marker position={localizacaoDestino} /> : null}

            </GoogleMap> : null}
        </div>
    )
}